import axios from 'axios';
import { useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router';
import { Button } from '../../components';
import { Checkbox } from '../../components/common/Checkbox/Checkbox';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import { H3, P2 } from '../../styles/FontStyles';
import { Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconXCircle } from '../../styles/Icons';
import { Main } from '../../layout/AuthLayout/authLayoutStyled';

export const LicenceExpiring = ({ history }: RouteComponentProps) => {
  const [checkbox, setCheckbox] = useState(false);

  const firstLogin = async () => {
    try {
      // await axios.put(`/user/set-first-login-popup-checked`);
      history.push(SETTINGS_VIRTUAL_OFFICE);
    } catch (error: any) {
      console.log(error.response);
    }
  };

  return (
    <div>
      <Flexed justifyCenter>
        <svg
          width='117'
          height='117'
          viewBox='0 0 117 117'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M64.4722 16.2726L106.329 88.7674C106.967 89.8729 107.303 91.1268 107.303 92.4033C107.303 93.6797 106.967 94.9337 106.329 96.0391C105.69 97.1446 104.772 98.0626 103.667 98.7008C102.562 99.3391 101.308 99.6751 100.031 99.6751H16.3185C15.042 99.6751 13.7881 99.3391 12.6826 98.7008C11.5772 98.0626 10.6593 97.1446 10.0211 96.0391C9.38285 94.9337 9.04687 93.6797 9.04688 92.4033C9.04688 91.1268 9.38288 89.8729 10.0211 88.7674L51.8775 16.2726C54.6747 11.4248 61.6702 11.4248 64.4722 16.2726ZM58.1749 16.2726L14.4238 92.4033H102.424L58.1749 16.2726ZM58.1749 73.7294C59.4606 73.7294 60.6937 74.2401 61.6028 75.1493C62.512 76.0584 63.0227 77.2915 63.0227 78.5772C63.0227 79.863 62.512 81.0961 61.6028 82.0052C60.6937 82.9144 59.4606 83.4251 58.1749 83.4251C56.8891 83.4251 55.6561 82.9144 54.7469 82.0052C53.8378 81.0961 53.327 79.863 53.327 78.5772C53.327 77.2915 53.8378 76.0584 54.7469 75.1493C55.6561 74.2401 56.8891 73.7294 58.1749 73.7294ZM58.1749 39.7944C59.4606 39.7944 60.6937 40.3052 61.6028 41.2143C62.512 42.1235 63.0227 43.3565 63.0227 44.6423V64.0337C63.0227 65.3194 62.512 66.5525 61.6028 67.4616C60.6937 68.3708 59.4606 68.8815 58.1749 68.8815C56.8891 68.8815 55.6561 68.3708 54.7469 67.4616C53.8378 66.5525 53.327 65.3194 53.327 64.0337V44.6423C53.327 43.3565 53.8378 42.1235 54.7469 41.2143C55.6561 40.3052 56.8891 39.7944 58.1749 39.7944Z'
            fill='#A97C29'
          />
        </svg>
      </Flexed>

      <H3 center mb='10' color={colors.neutral900}>
        Back-office subscription needed
      </H3>

      <P2 mb='50' center color={colors.neutral900}>
        If you haven't purchased Back-Office Subscription <br />
        <b> within the 30 days you will lose Partner benefits</b>
      </P2>

      <Flexed alignStart gap='10px' mb='15'>
        <Icon>
          <IconXCircle />
        </Icon>
        <P2 color={colors.neutral900}>Business Volume Points (BV)</P2>
      </Flexed>

      <Flexed alignStart gap='10px' mb='32'>
        <Icon>
          <IconXCircle />
        </Icon>
        <P2 color={colors.neutral900}>
          Bonuses (Team Bonus, Matching Bonus, Direct Bonus is capped to 100
          USDT per week)
        </P2>
      </Flexed>

      <Flexed mb='40' alignStart>
        <Checkbox
          checkColor={colors.primary900}
          margin={'0 10px 0 0'}
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
        />
        <P2 color={colors.neutral900}>
          I am aware, that without BO subscription I will lose BV points
          accumulated and bonuses
        </P2>
      </Flexed>

      <Button negative disabled={!checkbox} onClick={firstLogin}>
        Continue
      </Button>
    </div>
  );
};
